import React from 'react';

const ActionSpinner = () => (
  <div className='loading-container'>
    <div className='semicircle-spinner'>
      <div>
        <div>
          <div>
            <div>
              <div />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ActionSpinner;
